export const ALL_ICON_NAMES = [
    '360-avito',
    'abs-bmw',
    'abs',
    'acceleration',
    'airbag-bmw',
    'airbag',
    'arrow-back-oval-avito',
    'arrow-down-generic-v2',
    'arrow-down-nissan',
    'arrow-down',
    'arrow-green-left-avito',
    'arrow-green-right-avito',
    'arrow-left-generic-v2',
    'arrow-left-nissan',
    'arrow-left',
    'arrow-right-generic-v2',
    'arrow-right-nissan',
    'arrow-right',
    'arrow-up-generic-v2',
    'arrow-up-nissan',
    'arrow-up',
    'auto-avito',
    'axle-load-bmw',
    'axle-load',
    'battery-bmw',
    'battery',
    'belt-bmw',
    'belt',
    'burger-bmw',
    'burger-nissan',
    'burger',
    'calc-bmw',
    'calc-nissan',
    'calc',
    'calendar-bmw',
    'calendar-nissan',
    'calendar',
    'cancel-bmw',
    'cancel-nissan',
    'cancel',
    'car-avito',
    'car-front-bmw',
    'car-front-nissan',
    'car-front',
    'car-seat-left',
    'car-seat-right',
    'carrying-bmw',
    'carrying-nissan',
    'carrying',
    'cart-bmw',
    'cart-nissan',
    'cart',
    'check-bmw',
    'check-nissan',
    'check',
    'checkin-shield-avito',
    'checkmark-generic-v2',
    'chevron-left-bmw',
    'chevron-left-nissan',
    'chevron-left',
    'chevron-right-bmw',
    'chevron-right-nissan',
    'chevron-right',
    'compare-2',
    'compare',
    'document-bmw',
    'document-nissan',
    'document',
    'download-bmw',
    'download-nissan',
    'download',
    'eco-bmw',
    'eco',
    'edit-bmw',
    'edit-nissan',
    'edit',
    'engine-2',
    'engine-bmw',
    'engine',
    'esp-bmw',
    'esp-nissan',
    'esp',
    'eye',
    'facebook',
    'filter',
    'foursquare',
    'fuel-2',
    'fuel-bmw',
    'fuel',
    'globe',
    'google-plus',
    'grid-nissan',
    'grid',
    'heart-2',
    'heart-black',
    'heart',
    'height-bmw',
    'height-nissan',
    'height',
    'info-bmw',
    'info-nissan',
    'info',
    'info2',
    'instagram',
    'interior-avito',
    'length-bmw',
    'length',
    'lights-bmw',
    'lights-fog-bmw',
    'lights-fog',
    'lights-low-bmw',
    'lights-low',
    'lights',
    'link-bmw',
    'link-nissan',
    'link',
    'linkedin',
    'list-bmw',
    'list-nissan',
    'list',
    'loader',
    'location-bmw',
    'location-cctruck',
    'location-generic-v2',
    'location',
    'mail-bmw',
    'mail-nissan',
    'mail',
    'mileage',
    'minus-bmw',
    'minus-nissan',
    'minus',
    'navigation-small',
    'new-bmw',
    'new',
    'odnoklassniki',
    'offer-bmw',
    'offer',
    'oil-bmw',
    'oil-thermometer',
    'oil',
    'parking-bmw',
    'parking',
    'pdf',
    'personal-lk-avito',
    'phone-bmw',
    'phone-nissan',
    'phone',
    'pin',
    'pin2',
    'placeholder-bmw',
    'placeholder-generic-v2',
    'placeholder-nissan',
    'placeholder',
    'plus-bmw',
    'plus-nissan',
    'plus',
    'print',
    'question-bmw',
    'question-nissan',
    'question',
    'register-bmw',
    'register-nissan',
    'register',
    'reportVin',
    'rubleInCircle',
    'search-avito',
    'search-bmw',
    'search-nissan',
    'search',
    'seat-bmw',
    'seat-heat-bmw',
    'seat-heat',
    'seat',
    'secondary-arrow-down-bmw',
    'secondary-arrow-down-nissan',
    'secondary-arrow-down',
    'secondary-arrow-up-bmw',
    'secondary-arrow-up-nissan',
    'secondary-arrow-up',
    'secondary-check-bmw',
    'secondary-check-nissan',
    'secondary-check',
    'settings-bmw',
    'settings-nissan',
    'settings',
    'sort-asc',
    'sort-desc',
    'spec-price-bmw',
    'spec-price',
    'spec-vehicles-bmw',
    'spec-vehicles',
    'star-bmw',
    'star-nissan',
    'star',
    'telegram',
    'telegram2',
    'test-drive-bmw',
    'test-drive-nissan',
    'test-drive',
    'tiktok',
    'time-bmw',
    'time-nissan',
    'time',
    'tools-bmw',
    'tools-nissan',
    'tools',
    'trade-in-bmw',
    'trade-in-nissan',
    'trade-in',
    'transmission-a-2',
    'transmission-a-bmw',
    'transmission-a',
    'transmission-m-2',
    'transmission-m-bmw',
    'transmission-m',
    'trash-bmw',
    'trash-nissan',
    'trash',
    'twitter',
    'user-2',
    'user-bmw',
    'user-nissan',
    'user',
    'verified-avito',
    'viber',
    'video-avito',
    'video-button',
    'video-grey',
    'video-play',
    'video-play2',
    'video3',
    'visible-avito',
    'vkontakte',
    'whatsapp',
    'wheel-back-2',
    'wheel-back-bmw',
    'wheel-back',
    'wheel-front-2',
    'wheel-front-bmw',
    'wheel-front',
    'wheel-full-2',
    'wheel-full-bmw',
    'wheel-full',
    'widget-menu',
    'windshield-heat-bmw',
    'windshield-heat',
    'yandex-zen',
    'youtube',
    'zzzzzz-arrow-left',
    'zzzzzz-arrow-right',
    'zzzzzz-minus',
    'zzzzzz-plus',
];
